import { LocalStorageKeys } from './handleFormChange';

const handleClearStorage = () => {
  localStorage.removeItem(LocalStorageKeys.formDataCreateAgent);
};

export default handleClearStorage;
